module.exports = __webpack_public_path__ + "assets/c716bb2307dca8f1a2ef83c18575284b.jpg";